import { IconCaretLeft } from '@/components/icons/IconCaretLeft';
import { IconCaretRight } from '@/components/icons/IconCaretRight';
import { cn } from '@/lib/utils/tw-merge';

type VehicleGalleryArrowProps = {
    direction: 'prev' | 'next';
    /** At the end of the gallery the button stays focusable, it just does nothing. */
    atEnd: boolean;
    onStep: () => void;
    onDark?: boolean;
};

export function VehicleGalleryArrow({ direction, atEnd, onStep, onDark = false }: VehicleGalleryArrowProps) {
    const Icon = direction === 'prev' ? IconCaretLeft : IconCaretRight;

    return (
        <button
            type="button"
            className={cn(
                'vehicle-gallery__arrow',
                `vehicle-gallery__arrow--${direction}`,
                onDark && 'vehicle-gallery__arrow--on-dark',
            )}
            aria-label={direction === 'prev' ? 'Vorheriges Bild' : 'Nächstes Bild'}
            aria-disabled={atEnd}
            onClick={() => {
                if (!atEnd) onStep();
            }}
        >
            <Icon width={20} height={20} aria-hidden="true" />
        </button>
    );
}
